import { makeStyles } from '@material-ui/core/styles';

export default makeStyles((themem) => ({
    paginationRoot: {
        display: 'flex',
        justifyContent: 'center',
        marginRight: '10vw',
    },
    pagination: {
        margin: '25px 0px',
    }, 
    root: {
        marginBottom: '40px',
    }
}))